import React from 'react'
import yoniGAS from '../IMG/YONI-GAS.jpg'
import yobaniiGAS from '../IMG/YOBANI-GAS.jpg'
export default function Team() {
          
  return (
    <>
      <section>
        <div id="equipo" className="w-75 m-auto text-center">
          <h1 className="mb-5 fs-2">
            Equipo pequeño con resultados{" "}
            <span className="colorsito">GRANDES </span>
          </h1>
          <section className="container-fluid my-5">
            <div className=" ">
              <div className="mx-md d-flex justify-content-start ">
      <img className='rounded-circle ' src={yoniGAS} alt="YONI GAS-AUTO-GAS-YONI" />
                <p className="fs-6">
                <span className='colorsito'> YoniGas</span>  es un instalador de gas propano con más de 20 años de experiencia en el sector. Desde joven, YoniGas siempre se ha sentido atraído por el mundo de  y la instalación de gas, por lo que decidió formarse en esta área y especializarse en la instalación de gas propano.

Durante sus primeros años en el sector, YoniGas trabajó para varias empresas de instalación de gas, aprendiendo todo lo que podía sobre la instalación y mantenimiento de sistemas de gas propano. Con el tiempo, YoniGas se convirtió en uno de los instaladores de gas más reconocidos de la región, gracias a su habilidad para solucionar problemas y su compromiso con la seguridad de sus clientes.

Hoy en día, YoniGas trabaja como instalador independiente, atendiendo a clientes en toda la región. Se ha ganado una excelente reputación gracias a su profesionalismo y su dedicación a su trabajo. Además, siempre está dispuesto a ayudar a sus clientes con cualquier duda o problema que tengan, lo que lo convierte en un instalador de gas propano muy valorado por su comunidad.
                </p>
              </div>

              <div className="mx-md d-flex justify-content-start">
               <img className='rounded-circle' src={yobaniiGAS} alt="YONI GAS-AUTO-GAS-YONI" />

                <p className="fs-6">
                  La esposa de YoniGas, llamada <span className='colorsito'>YobaniGas</span> , también es instaladora de gas propano y tiene una experiencia similar en el sector. YobaniGas se interesó por la  instalación de gas desde muy joven, y trabajó arduamente para aprender todo lo necesario para convertirse en una instaladora de gas propano de alta calidad.

Al principio, YobaniGas trabajó en colaboración con YoniGas en la misma empresa de instalación de gas, donde demostró su gran habilidad en la instalación y mantenimiento de sistemas de gas propano

Hoy en día, YobaniGas es una de las pocas mujeres instaladoras de gas en la región y se ha ganado una excelente reputación por su trabajo. Sus clientes la valoran por su profesionalismo y su dedicación a la seguridad de sus sistemas de gas propano. Además, YobaniGas es una defensora de la igualdad de género en su sector y trabaja para inspirar a otras mujeres a seguir sus pasos y perseguir sus sueños en el mundo de la  la instalación de gas.
                </p>
              </div>
            </div>

         
          </section>
        </div>
      </section>
    </>
  );
}
